<template>
  <BLayoutEmpty>
    <template #container>
      <v-layout class="my-2">
        <div class="BLayoutList__top">
          <h1 class="text-h5">
            {{ title }}
          </h1>

          <v-spacer />

          <slot name="before-add" />

          <template v-if="createRoute">
            <v-skeleton-loader :loading="skeleton" type="button">
              <v-btn :to="createRoute" depressed>
                Добавить
              </v-btn>
            </v-skeleton-loader>
          </template>
        </div>
      </v-layout>

      <slot name="filter" />
    </template>

    <template #after>
      <slot />
    </template>
  </BLayoutEmpty>
</template>

<script>
import BLayoutEmpty from './BLayoutEmpty.vue'

export default {
  name: 'BLayoutList',
  components: {
    BLayoutEmpty,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    skeleton: Boolean,
    createRoute: [String, Object],
  },
}
</script>

<style lang="scss">
.BLayoutList {
  &__top {
    display: flex;
    align-items: center;
    width: 100%;
  }
}
</style>
